import { BasePageModel } from 'models/BasePageModel';
import { PageState } from 'models/PageState';
import { StockStatus } from 'models/ProductMeta';
export const getCart = (state: PageState) => state.cart;

export const getSubItemRelations = (state: PageState) => state.cart.subItemRelations;
export const getBobSubItemRelations = (state: PageState) => state.cart.bobSubItemRelations;
export const getShouldHideDiscountfield = (state: PageState) => state.cart.shouldHideDiscountField;

export const getCartItems = (state: PageState) => state.cart.cartItems;

export const hasStockStatusCreateItems = ({ cart: { cartItems } }: PageState) =>
  cartItems.some(({ meta: { stockStatus } }) => stockStatus === StockStatus.Create);

export const getHasRotDeduction = (state: PageState) => state.cart.hasRotDeduction;

export const getHasRentalProduct = (state: PageState) => state.cart.hasRentalProducts;

export const getContainsOnlyRentalProducts = (state: PageState) => {
  if (!state.cart.hasRentalProducts) return false;

  return state.cart.cartItems.every(item => item.rentalPrice > 0);
};

export const getCurrentPage = (state: PageState): BasePageModel => state.currentPage;
